<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	margin-bottom:150px;
	.top
		width:100%;
		height:492px;
		position: relative;
		background:url('../../../static/img/aboutCompany.png') no-repeat;
		background-size: 100% 100%;
		.top-main
			position: absolute;
			// bottom:50px;
			bottom:-90px;
			right:90px;
			color:#fff;
			font-size:48px;
	.center
		text-align:center;
		padding:55px 0px;
		.c-title
			border-bottom:1px solid #CECECE;
			font-size:22px;
			font-weight: 500;
			color:#000000;
		.c-title-english
			color:#8D8D8D;
			height:20px;
			line-height:20px;
			font-size: 14px;
	.about-hs
		padding:10px 25%;
		.about-img
			text-align:center;
			margin-bottom:70px;
		.about-desc
			font-size: 18px;
			color:#474645;
			line-height: 33px;
		.about-timeline
			.about-content
				color:#474645;
				font-size:16px;
				line-height:30px;
	.culture
		display:flex;
		justify-content:center;
		.culture-list
			margin:0 22px;
			align-items:center;
			display:flex;
			width:400px;
			.culture-name
				font-size:18px;
				color:#071336;
				margin-left:20px;
</style>
<style lang="stylus">
	.about-timeline
		.el-timeline-item__timestamp
			color:#000000;
			font-size:25px;
			font-weight:bold;
</style>
<template>
  <div class="main">
    <div class="top">
    	<div class="top-main">
    		<div>
    			<video height="310" width="534" src="https://honsenflagoss.honsenflag.com/video/introduce_video.mp4" controls></video>
    		</div>
    		<!-- <div>专注于企业法律服务</div> -->
    	</div>
    </div>

    <div class="center">
    	<div class="c-title">弘商法律云</div>
    	<div class="c-title-english">About  us</div>
    </div>

    <div class="about-hs">
    	<div class="about-img">
    		<img src="/static/img/honsen_name.png">
    	</div> 
    	<div class="about-desc">弘商法律云创立于2015年，源于广东美哲莱律师事务所的执着追求，始终专注于打造互联网时代的商事法律服务标准，秉
承“以法律驱动商业发展”的使命，汇聚为企业提供法律服务的律师，帮助中小企业实现持续、稳定的经营和发展。
弘商法律云颠覆传统法律服务理念和模式，致力于成为最懂企业的互联网法律服务平台，创新融合“互联网+法律+商业”，
深挖企业法律服务需求，倾力打造全新的“L2B”商事法律服务模式，为企业推出“企业法律咨询”、“企业法务通”和“企业法
务部”三大服务。</div>
		<div class="about-desc">目前，弘商法律云已经汇聚8000多名从事企业法律服务的律师，与政府相关部门、各行业协会以及工业园区合作，正在为
越来越多企业提供伴随式、可视化的法律服务。</div>
    </div>

    <div class="center">
    	<div class="c-title">发展历程</div>
    	<div class="c-title-english">Course</div>
    </div>
    <div class="about-hs">
    	<el-timeline class="about-timeline">
    		<el-timeline-item v-for="(item,index) in timeList" :key="item.timestamp" :timestamp="item.timestamp" placement="top">
    			<div v-html="item.desc" class="about-content"></div>
    		</el-timeline-item>
    	</el-timeline>
    </div>
    
    <div class="center">
    	<div class="c-title">企业文化</div>
    	<div class="c-title-english">Corporate  culture</div>
    </div>

    <div class="culture">
    	<div v-for="(item,index) in cultureList" class="culture-list">
    		<img :src="item.src">
    		<div class="culture-name">{{item.name}}</div>
    	</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comppanyProfile',
  data () {
    return {
      timeList:[
      	{timestamp:'2015',desc:'· 公司成立'},
      	{timestamp:'2016',desc:'· 公司组建了产品研究团队，确定了产品的雏形，开始投入人员开发产品。'},
      	{timestamp:'2017',desc:'· 弘商法律云平台1.0的正式发布，完成了第一轮融资。'},
      	{timestamp:'2018',desc:'· 弘商法律云平台2.0发布，平台认证律师8000多名，覆盖整个广东省。<br>· 推出企业法务通系列课程，为中小企业提供公益法律培训服务。'},
      	{timestamp:'2019',desc:'· 企业法务部产品上线，平台注册企业达到4700多家<br>· 与深圳前海股权交易中心建立合作关系，面向中小企业搭建梯度服务体系'},
      	{timestamp:'2020',desc:'· 疫情期间，向中小企业提供线上直播法律培训<br>· 与深圳市宝安区科技创新服务中心达成合作，为73个园区提供法律咨询服务，累计受理了近千家企业的法律咨询。<br>· 与深圳市宝安区司法局达成合作，推出“法援惠民,”云服务暨法律援助宣传月活动'},
      ],
      cultureList:[
      	{src:'/static/img/company_1.png',name:'弘扬商事法律服务'},
      	{src:'/static/img/company_2.png',name:'以法律驱动商业发展'},
      	{src:'/static/img/company_3.png',name:'成为最懂企业的互联网法律服务平台'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aboutHonsen/companyProfile.vue